import courses from "./Courses/routes";
import signatoryMatrixRoutes from "./SignatoryMatrix/routes";
import staffTraining from "./StaffTraining/routes";
import trainingMatrix from "./TrainingMatrix/routes";

// Matrices app switcher route (STC variant only)
// const matricesAppRoute = {
//     path: "/Matrices",
//     redirect: "/Matrices/SignatoryMatrix/Signatories",
//     name: "Competence & Matrices",
//     meta: {
//         app: "Matrices",
//         sideNav: false,
//         appSwitcher: true,
//         appSwitcherPosition: 3,
//         icon: "book",
//         name: "Competence & Matrices",
//         hidden(user) {
//             // Hide if user has NEITHER Training nor Matrices.Read
//             return user?.Security?.General?.Training !== true && 
//                    user?.Security?.Matrices?.Read !== true;
//         }
//     }
// };

export default [...signatoryMatrixRoutes, ...staffTraining, ...trainingMatrix, ...courses];
